import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorLayout } from '@/shared/components';
import { GUEST_ROUTES } from './routes.definitions';
import { WelcomePage } from './pages/welcome-page';
import { NewTablePage } from './pages/new-table-page';
import { JoinPage } from './pages/join-page';
import { TablePage } from './pages/table-page';

/** Routes available to everyone: visitors, guests and accounts. */
export const guestRoutes: RouteObject[] = [
  { path: GUEST_ROUTES.HOME, element: <WelcomePage /> },
  { path: GUEST_ROUTES.NEW_TABLE, element: <NewTablePage /> },
  { path: GUEST_ROUTES.JOIN, element: <JoinPage /> },
  { path: GUEST_ROUTES.TABLE, element: <TablePage /> },
].map(r => ({ ...r, errorElement: <ErrorLayout /> }));
